module.exports = __webpack_public_path__ + "img/base_activites_balade_fermes.5ee29a46.svg";